import { Link } from "react-router-dom";
import { PlayCircleIcon, PhotoIcon } from "@heroicons/react/24/solid";

const items = [
  {
    icon: PlayCircleIcon,
    title: "Videótár",
    img: "/images/image11.jpg",
    to: "/gallery",
  },
  {
    icon: PhotoIcon,
    title: "Képgaléria",
    img: "/images/image12.jpg",
    to: "/gallery",
  },
];

export default function ArchiveCTA() {
  return (
    <section className="bg-primary/5 py-20">
      <h2 className="mb-12 text-center text-3xl font-bold">Archívum</h2>
      <div className="mx-auto grid max-w-5xl gap-8 px-6 md:grid-cols-2">
        {items.map(({ icon: Icon, ...c }) => (
          <Link key={c.title} to={c.to} className="group relative block h-80 overflow-hidden rounded-lg shadow-lg">
            <img src={c.img} alt="" className="h-full w-full object-cover transition group-hover:scale-105" />
            <div className="absolute inset-0 bg-black/40" />
            <div className="absolute inset-0 flex flex-col justify-end p-6 text-white">
              <Icon className="h-10 w-10" />
              <h3 className="mt-2 text-2xl font-bold">{c.title}</h3>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
